import { render, staticRenderFns } from "./positivesalon-audio-player.vue?vue&type=template&id=3a269004&scoped=true&"
import script from "./positivesalon-audio-player.vue?vue&type=script&lang=js&"
export * from "./positivesalon-audio-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a269004",
  null
  
)

export default component.exports